import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { ProductCategory } from './ProductCategory'
import { ProductCategoryMapper } from './ProductCategoryMapper'

export class ProductCategoryCollection {
  protected collection: string = 'productCategory'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  list(): Promise<ProductCategory[]> {
    const query = this.initQuery()
    return query.list()
  }

  listProductCategoriesByParentId(parentId: string): Promise<ProductCategory[]> {
    const query = this.initQuery()
    query.setQuery(this.getProductCategoriesByParentIdQuery(query, parentId))
    return query.list()
  }

  listProductCategoriesByParentIdAndNoChildren(parentId: string): Promise<ProductCategory[]> {
    const query = this.initQuery()
    query.setQuery(this.getProductCategoriesByParentIdAndNoChildrenQuery(query, parentId))
    return query.list()
  }

  watch(id: string): { data: ProductCategory | null, unsub: () => void } {
    const query = this.initQuery()
    return query.watch(id)
  }

  async findProductCategoryByNameAndLineage(name: string, lineage: string[]): Promise<ProductCategory | null> {
    const query = this.initQuery()
    query.setQuery(
      query.collection(this.collection)
      .where('name', '==', name)
      .where('lineage', '==', lineage)
      .limit(1)
    )

    return ( await query.list() )[0]
  }

  get(id: string): Promise<ProductCategory | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  save(productCategory: ProductCategory): Promise<ProductCategory> {
    const query = this.initQuery()
    return query.save(productCategory)
  }

  async delete(productCategory: ProductCategory) {
    const query = this.initQuery();
    return query.delete(productCategory)
  }

  protected initQuery(): FirestoreQuery<ProductCategory> {
    const query = new FirestoreQuery<ProductCategory>(this.db, new ProductCategoryMapper())
    query.collection(this.collection)

    return query
  }

  protected getProductCategoriesByParentIdQuery(query: FirestoreQuery<ProductCategory>, parentId: string) {
    return query.collection(this.collection).where('parentId', '==', parentId)
  }

  protected getProductCategoriesByParentIdAndNoChildrenQuery(query: FirestoreQuery<ProductCategory>, parentId: string) {
    return query.collection(this.collection)
      .where('parentId', '==', parentId)
      .where('hasChildren', '==', false)
  }
}
